<template>
  <footer id="footer" class="footer_area">
    <div class="container">
      <div
        class="footer_wrapper text-center d-lg-flex align-items-center justify-content-between"
      >
        <div class="footer_social col-lg-12">
          <div class="row">
            <div class="col-lg-7">
                <div class="credit_header mb-10" style="text-align: left">
                  <span style="border-top: 2px solid white"
                    >Temukan Kami
                  </span>
                </div>
                <ul style="text-align: left">
                  <li><a target="_blank" href="https://facebook.com/csr.kai.39"><i class="lni lni-facebook"></i></a></li>
                  <li><a target="_blank" href="https://twitter.com/csr_kai"><i class="lni lni-twitter-original"></i></a></li>
                  <li><a target="_blank" href="https://www.youtube.com/channel/UC9fYwOjxf94vsDf1I7Udpow"><i class="lni lni-youtube"></i></a></li>
                  <li><a target="_blank" href="https://instagram.com/csrkai"><i class="lni lni-instagram-original"></i></a></li>
                </ul>
            </div>
            <div class="col-lg-5">
                <div class="footer_social col-md-12" style="text-align: left" >
                  <span class="credit_header">TJSL PT Kereta Api Indonesia (Persero)</span>
                  <div class="col-md-12">
                    <span class="credit">Jl. Perintis Kemerdekaan No.1 Kota Bandung, Jawa Barat. 40117</span>
                  </div>
                  <div class="col-md-12">
                    <!-- <span class="credit"><i class="lni lni-phone"></i>&nbsp; Telepon 022-4230031
                      &nbsp;ext.10435
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span> -->
                    <span class="credit">
                      <i class="lni lni-whatsapp"></i>&nbsp; WHATSAPP 0821 1000 2942
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    <span class="credit">
                      <i class="lni lni-envelope"></i>&nbsp; email csr@kai.id&nbsp;
                    </span>
                  </div>
                </div>
            </div>
          </div>
          <div class="row" style="text-align: center">
            <div>
              <span class="credit mt-10">
                TJSL
                <a href="https://kai.id/" rel="nofollow"
                  >PT. Kereta Api Indonesia (Persero)</a
                >
                © {{ new Date().getFullYear() }}. &nbsp;
              </span>
              <span class="credit"> All Rights Reserved </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
  <a class="book-ticket rotate" target="_blank" href="https://kai.id" style="cursor: pointer">PEMESANAN TIKET</a>
  <a class="contact-us" title="Hubungi Kami" target="_blank" href="https://wa.me/6282110002942?text=" style="cursor: pointer">
  <i class="lni lni-whatsapp"></i>
  <!-- <span style="font-size: 20px;">Hubungi Kami</span> -->
  </a>
  <a class="back-to-top" title="" @click="retrieveButtonbtt()" style="cursor: pointer"
    ><i class="lni lni-chevron-up"></i
  ></a>
</template>
<script>
// import VueWow from 'vue-wow'
export default {
  methods: {
    fadeout() {
      document.querySelector(".preloader").style.opacity = "0";
      document.querySelector(".preloader").style.display = "none";
    },
    retrieveButtonbtt() {
      window.scrollTo(0, 2);
    },
    handleScroll() {
      var header_navbar = document.getElementById("header_navbar");
      var logo = document.querySelector("img#logo");
      var sticky = header_navbar.offsetTop;
      if (window.pageYOffset > sticky) {
        header_navbar.classList.add("sticky");
        logo.setAttribute("src", "assets/images/logokaiv4.png");
      } else {
        header_navbar.classList.add("sticky");
        logo.setAttribute("src", "assets/images/logokaiv4.png");
      }
      var backToTo = document.querySelector(".back-to-top");
      var bookTicket = document.querySelector(".book-ticket");
      var contactUs = document.querySelector(".contact-us");
      if (
        document.body.scrollTop > 100 ||
        document.documentElement.scrollTop > 100
      ) {
        backToTo.style.display = "block";
        bookTicket.style.display = "block";
        contactUs.style.display = "block";
      } else {
        backToTo.style.display = "none";
        bookTicket.style.display = "block";
        contactUs.style.display = "none";
      }
    },
    onScroll() {
      var scrollTopMinus = "";
      var offsettop = "";
      var offsetheight = "";
      var sections = document.querySelectorAll(".page-scroll");
      var scrollPos =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      for (var i = 0; i < sections.length; i++) {
        var currLink = sections[i];
        var val = currLink.getAttribute("href");
        // var refElement = document.querySelector(val);
        let result = val.replace("#", "");
        var refElement = document.querySelector("[id='" + result + "']");
        // console.log(sections.length);
        scrollTopMinus = scrollPos + 200;
        if (refElement != null) {
          offsettop = refElement.offsetTop;
          offsetheight = refElement.offsetHeight;
          if (
            offsettop <= scrollTopMinus &&
            offsettop + offsetheight > scrollTopMinus
          ) {
            document.querySelector(".page-scroll").classList.remove("active");
            currLink.classList.add("active");
          } else {
            currLink.classList.remove("active");
          }
        }
      }
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("scroll", this.onScroll);
  },
  unmounted() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("scroll", this.onScroll);
  },
  updated() {
    document.addEventListener("DOMContentLoaded", function () {
      document.addEventListener("scroll", this.onScroll);
    });
  },
  mounted() {
    window.setTimeout(this.fadeout, 500);
    this.retrieveButtonbtt();
  },
};
</script>
